import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { City, CityCreate, CityFilter } from '../data/city';

export function createCityService(client: AxiosInstance) {
  return createCrudService<City, CityCreate, CityFilter>(
    client,
    '/master-data/City',
    'id',
  );
}

export type CityService = CrudService<City, CityCreate, CityFilter>;
